// extracted by mini-css-extract-plugin
export default {"soracomSIMCreateButton":"soracom-sims_soracomSIMCreateButton__b4sbN","soracomSIMEditButton":"soracom-sims_soracomSIMEditButton__NSdpL"};